/* unplugin-vue-components disabled */import { render } from "./GraphMatchMatrix.vue?vue&type=template&id=1a1559ba&scoped=true"
import script from "./GraphMatchMatrix.vue?vue&type=script&lang=js"
export * from "./GraphMatchMatrix.vue?vue&type=script&lang=js"

import "./GraphMatchMatrix.vue?vue&type=style&index=0&id=1a1559ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1559ba"]])

export default __exports__